<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('personal savings account requests')"
      :columns="columns"
      :column_search="false"
      resource_url="/account-request/personal-savings/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modal para crear/editar -->
    <request-modal ref="request_modal" @success="refresh_datatable" />
    <view-modal ref="view_modal" @success="refresh_datatable" />
    <log-modal ref="log_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import RequestModal from "./request_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import ViewModal from "./view_modal/Index.vue";
import moment from "moment";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  format_date_time,
  download,
  success_message,
  error_message,
} from "@/utils";

export default {
  name: "AccountRequestDataTable",
  components: {
    GenericTable,
    RequestModal,
    LogModal,
    ViewModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: this.$t("destinatary"),
          data: (row) =>
            `<div class="title is-6"><span class="icon"><i class="fa fa-user"></i></span>${row.destinatary.name}</div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-id-card"></i></span>${row.destinatary.dpi}</div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-envelope"></i></span>${row.destinatary.email}</div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-phone"></i></span>${row.destinatary.phone}</div>`,
        },
        {
          title: this.$t("entity"),
          data: (row) =>
            `<div class="title is-6">${row.entity.name}</div>            
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-calendar"></i></span>${format_date_time(
              row.create_date
            )}</div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-user"></i></span>${
              row.create_user?.username
            }</div>`,
        },
        {
          title: this.$t("request information"),
          data: (row) => {
            let status_class = "is-info";
            let status_icon = "fa fa-question-circle";
            if (row.status == "unopened") {
              status_class = "is-warning";
              status_icon = "fa fa-hourglass-start";
            } else if (row.status == "in-progress") {
              status_class = "is-warning";
              status_icon = "fa fa-hourglass-half";
            } else if (row.status == "documentation-completed") {
              status_class = "is-primary";
              status_icon = "fa fa-check-circle";
            }
            let status_tag = `<div class="tags has-addons">
                                <span class="tag ${status_class}">${this.$t(
              row.status
            )}</span>
                                <a class="tag">
                                  <span class="icon"><i class="${status_icon}"></i></span>
                                </a>
                              </div>`;
            // let status_tag = `<span class="tag ${status_class} is-dark is-medium"><span class="icon"><i class="${status_icon}"></i></span>${v.$t(
            //   row.status
            // )}</span>`;
            let product_div = `<div class="title is-6 mb-2">${row.product.name}</div>`;
            return product_div + status_tag;
          },
        },
        // {
        //   title: this.$t("data"),
        //   data: (row) => `<pre>${JSON.stringify(row, null, 2)}</pre>`,
        // },
        {
          title: this.$t("actions"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("view request"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  this.view(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("view as customer"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  window.open(
                    `/account-request/personal-savings/perform/${row.uuid}`,
                    "_blank"
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: (e) => {
                  this.log(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  this.delete(row);
                },
              },
            ];

            if (row.has_captured_data) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: this.$t("generate pdf"),
                icon: "fa fa-file-pdf-o",
                icon_class: "is-small has-text-primary",
                click: (e) => {
                  this.generate_pdf(row);
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.request_modal.show_modal();
    },
    delete(row) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete personal savings account request?"),
        v,
        () => {
          del("/account-request/personal-savings", { uuid: row.uuid })
            .then(() => {
              v.refresh_datatable();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
    log(row) {
      let v = this;
      v.$refs.log_modal.show(row.uuid);
    },
    view(row) {
      let v = this;
      v.$refs.view_modal.show(row.uuid);
    },
    generate_pdf(row) {
      let v = this;
      download(
        `/account-request/personal-savings/pdf?uuid=${row.uuid}`,
        `${row.name}-${moment().format("YYYYMMDDHHmmss")}.pdf`
      )
        .then(() => {
          success_message(v.$t("download complete"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
